import { styled, Typography, selectTheme, Box } from '@creditas-ui/react'

const colorRule = ({ status }) => {
  switch (status) {
    case 'Aprovado':
      return selectTheme('colors.primary.90')
    case 'Não aprovado':
      return selectTheme('colors.error.60')
    case 'Em análise':
      return selectTheme('colors.informational.60')
    case 'Pendente':
      return selectTheme('colors.warning.60')
    default:
      return selectTheme('colors.neutral.90')
  }
}

export const CustomColorTypography = styled(Typography)`
  color: ${colorRule};
`

export const CustomTypography = styled(Typography)`
  margin-top: 24px;

  @media screen and (min-width: 980px) {
    margin-top: 0;
  }
`

export const ItemInformationDetail = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;

  div:nth-of-type(2) {
    margin-left: 0;
  }

  @media screen and (min-width: 980px) {
    flex-direction: row;

    div:nth-of-type(2) {
      margin-left: 58px;
    }
  }
`
